module.exports = __webpack_public_path__ + "img/UpGPT-B.2937ca4f.svg";